module.exports = __webpack_public_path__ + "img/J12157.db03c71b.png";